<template>
  <div class="pay-record-export-container">
    <el-button type="primary" size="mini" icon="el-icon-download" plain @click="handelClick">导出
    </el-button>
    <div
        v-if="loading"
        class="mask"
    >
      <div style="text-align: center;">
        <el-progress
            type="circle"
            :percentage="percentage"
            text-color="white"
        />
        <h2 style="color: #FFFFFF;text-align: center;">下载中...</h2>
        <h3 style="color: #FFFFFF;text-align: center;">
          下载订单数 {{ total }} 条，已用时 {{ (interval_ms / 1000)|numberFormat(2) }} s
        </h3>
      </div>
    </div>
  </div>
</template>
<script>
import {export_json_to_excel} from '@/utils/export/excel'
import {getPayRecordList} from "@/api/payRecord";

/**
 * 导出头部
 */
const fieldMap = {
  '序号': 'index',
  '状态': 'claim_status_alias',
  '编号': 'id',
  '收款日期': 'pay_date',
  '付款方名称': 'payer',
  '收款金额': 'account',
  '银行账号': 'bank_account',
  '开户行': 'bank_name',
  '收款方': 'rec_name',
  '收款方式': 'pay_method',
  '备注': 'remark',
  '认领明细': {
    '状态': 'check_status_alias',
    '认领人': 'owner_name',
    '认领时间': 'created_at',
    '订单编号': 'order_no',
    '乙方名称': 'company_name',
    '客户名称': 'customer_name',
    '合同归档': 'contract_filed_alias',
    '合同编号': 'contract_no',
    '合同金额': 'contract_amount',
    '开票状态': 'invoice_status_alias',
    '下单时间': 'created_date',
    '要求发布时间': 'release_at',
    '是否执行': 'bool_exec_alias',
    '回款状态': 'pay_status_alias',
    '含税收入': 'payment_account',
    '剩余金额': 'sum_amount',
    '本次回款金额': 'payment',
    '认领备注': 'payment_remark',
    '红人名称': 'artist_name',
    '平台': 'platforms',
    '品牌': 'brand',
    '产品/内容': 'product'
  },
}
export default {
  name: 'PayRecordExport',
  props: {
    search: {
      type: Object,
      required: true
    },
    beforeExport: {
      type: [Function, Boolean],
      default() {
        return false;
      }
    },
  },
  data() {
    return {
      loading: false,
      interval: null,
      interval_ms: 0,
      total: 0,
      percentage: 0
    }
  },
  methods: {
    handelClick: async function () {
      // 导出前执行方法
      this.beforeExport && this.beforeExport()

      const _this = this
      const callback = () => {
        _this.$message.success('导出成功')
        _this.interval_ms = 0
        _this.interval_ms && clearInterval(_this.interval_ms)
      }
      _this.interval = setInterval(function () {
        _this.interval_ms += 10
      }, 10)

      this.percentage = 0
      this.loading = true
      const json = await this.getData()
      this.loading = false
      const {array: tableData, merges} = this.filterJson(json)

      export_json_to_excel(
          {
            fieldMap,
            sourceData: tableData,
            filename: '导出数据',
            mergeColumns: merges
          }, callback
      )
    },
    getData: async function () {
      let array = []
      const params = {...{}, ...this.search}
      params.is_export = true
      params.page = 1
      params.per_page = 100
      const {model: {total}} = await getPayRecordList(params)
      if (total > 10000) {
        params.per_page = 1000
      } else if (total > 1000) {
        params.per_page = 500
      } else {
        params.per_page = 100
      }

      this.total = total
      for (let i = 0; i < total; i += params.per_page) {
        const {model: {data}} = await getPayRecordList(params)
        array = [...array, ...data]
        params.page++
        this.percentage = parseInt((i * 100 / total) + '')
      }
      return array
    },
    filterJson(json) {
      const fields = Object.values(fieldMap)
      const children_fields = Object.values(fieldMap['认领明细'])

      let merge_index = 3
      let merge_end_index = 0
      const array = []
      const merges = []
      json.forEach((record, index) => {
        if (Array.isArray(record.children)) {
          if (record.children.length) {
            record.children.map((child) => {
              const obj = {}
              fields.map(field => {
                if (typeof field === 'string') {
                  obj[field] = record[field] || null
                }
              })
              children_fields.map(field => {
                obj[field] = child[field] || null
              })
              obj.index = (index + 1)
              array.push(obj)

              // 合并逻辑
              const merge_start_index = merge_index
              if (merge_start_index > merge_end_index) {
                merge_end_index = merge_index + (record.children.length) - 1;
                ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K',].map(_c => {
                  merges.push(`${_c}${merge_start_index}:${_c}${merge_end_index}`)
                })
              }
              merge_index++
            })

          } else {
            const obj = {}
            fields.map(field => {
              if (typeof field === 'string') {
                obj[field] = record[field] || null
              }
            })
            obj.index = (index + 1)
            array.push(obj)
            merge_index++
          }
        }
      })
      return {array, merges}
    }
  }
}

</script>
<style lang="scss">
.pay-record-export-container {
  display: inline-block;

  .el-button [class*=el-icon-] + span {
    margin-left: 0;
  }

  .mask {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: rgba(0, 0, 0, .8); /*一般遮罩随便设置一个颜色*/
    z-index: 1001;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
